<template>
    <div class="nav-tabs nav-tabs--services nav-tabs--padding | u-margin-left-flush">
        <div :class="{ 'is-active': step == 1 }" class="nav-tabs__item" data-nav-tab="dns">
            <span class="nav-tabs__title nav-tabs__title-responsive | u-margin-right-narrow">
                <customer-router-link
                    class="link-tabs"
                    :to="{ name: 'dnsOverview', params: { domain: domain } }"
                    :class="{ 'is-active': step == 1 }"
                >
                    <span class="u-display--none-portable">
                        {{ trans('order.dns') }}
                    </span>
                    <img class="u-display--none-desk" src="../assets/feather-icons/dns.svg" />
                </customer-router-link>
            </span>
        </div>
        <div :class="{ 'is-active': step == 2 }" class="nav-tabs__item" data-nav-tab="domain">
            <span class="nav-tabs__title nav-tabs__title-responsive | u-margin-right-narrow">
                <customer-router-link
                    class="link-tabs"
                    :to="{ name: 'domainOverview', params: { domain: domain } }"
                    :class="{ 'is-active': step == 2 }"
                >
                    <span class="u-display--none-portable">
                        {{ trans('order.domain-name') }}
                    </span>
                    <img class="u-display--none-desk" src="../assets/feather-icons/globe.svg" />
                </customer-router-link>
            </span>
        </div>
        <div :class="{ 'is-active': step == 3 }" class="nav-tabs__item" data-nav-tab="hosting">
            <span class="nav-tabs__title nav-tabs__title-responsive | u-margin-right-narrow">
                <customer-router-link
                    class="link-tabs"
                    :to="{ name: 'hostingOverview', params: { domain: domain } }"
                    :class="{ 'is-active': step == 3 }"
                >
                    <span class="u-display--none-portable">
                        {{ trans('order.hosting') }}
                    </span>
                    <img class="u-display--none-desk" src="../assets/feather-icons/database.svg" />
                </customer-router-link>
            </span>
        </div>
        <div :class="{ 'is-active': step == 4 }" class="nav-tabs__item" data-nav-tab="ssl">
            <span class="nav-tabs__title nav-tabs__title-responsive | u-margin-right-narrow">
                <customer-router-link
                    class="link-tabs"
                    :to="{ name: 'sslOverview', params: { domain: domain } }"
                    :class="{ 'is-active': step == 4 }"
                >
                    <span class="u-display--none-portable">
                        {{ trans('order.ssl') }}
                    </span>
                    <img class="u-display--none-desk" src="../assets/feather-icons/lock.svg" />
                </customer-router-link>
            </span>
        </div>
        <div :class="{ 'is-active': step == 5 }" class="nav-tabs__item" data-nav-tab="vps" v-if="canAccessVps">
            <span class="nav-tabs__title nav-tabs__title-responsive | u-margin-right-narrow">
                <customer-router-link
                        class="link-tabs"
                        :to="{ name: 'vpsOverview', params: { domain: domain } }"
                        :class="{ 'is-active': step == 5 }"
                >
                    <span class="u-display--none-portable">
                        {{ trans('order.vps') }}
                    </span>
                    <img class="u-display--none-desk" src="../assets/feather-icons/lock.svg" />
                </customer-router-link>
            </span>
        </div>
        <div
            v-if="canChangeCustomer"
            :class="{ 'is-active': step == 6 }"
            class="nav-tabs__item"
            data-nav-tab="customer"
        >
            <span class="nav-tabs__title nav-tabs__title-responsive">
                <customer-router-link
                    class="link-tabs"
                    :to="{ name: 'serviceCustomer', params: { domain: domain } }"
                    :class="{ 'is-active': step == 6 }"
                >
                    <span class="u-display--none-portable">
                        {{ trans('order.customer') }}
                    </span>
                    <img class="u-display--none-desk" src="../assets/feather-icons/user.svg" />
                </customer-router-link>
            </span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import vps from '../../config/vps.json';

export default {
    props: {
        step: Number,
        domain: {
            type: String,
            required: true
        },
        service: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        ...mapGetters({
            userCan: 'services/can'
        }),
        /**
         * Check if the user can change the customer.
         *
         * @return {boolean}
         */
        canChangeCustomer() {
            return this.userCan({ item: this.service, action: 'changeCustomer' });
        },

        /**
         * Check if VPS functionality is enabled.
         *
         * @return {boolean}
         */
        canAccessVps() {
            return process.env.VUE_APP_VPS_ENABLED === 'true';
        }
    }
};
</script>
